import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";

import ProductItem from "./ProductItem";

interface IFormProduto {
  itens: ProdutoItemType[] | undefined;
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ProductType;
  error: boolean;
  textColor: string;
  brandStars: string;
  nome: string;
  changeNome: (value: string) => void;
  loading: boolean;
  save: () => void;
  changeItem: (item: ProdutoItemType, index: number) => void;
  deleteRow: (item: ProdutoItemType) => void;
  addRow: (item: ProdutoItemType) => void;
  borderColor: string;
  errorTitle: string;
  errorMsg: string;
  cancelRef: any;
  closeError: () => void;
  condicaoPagamentos: CondicaoPagamento[] | undefined;
}

const FormProduto = ({
  showModal,
  show,
  accountSelected,
  error,
  brandStars,
  nome,
  changeNome,
  textColor,
  loading,
  save,
  changeItem,
  deleteRow,
  addRow,
  borderColor,
  itens,
  errorMsg,
  errorTitle,
  cancelRef,
  closeError,
  condicaoPagamentos
}: IFormProduto) => {

  return (
    <>
      <Box>
        <Box>
          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Nome<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              defaultValue={accountSelected?.nome}
              isRequired={true}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o nome do Item"
              onChange={(e) => (changeNome(e.target.value))}
              mb="24px"
              fontWeight="500"
              size="lg"
            />
            {error && (
              <FormErrorMessage>
                Preencha Corretamente o Campo.
              </FormErrorMessage>
            )}
          </FormControl>

          <Text
            textAlign="left"
            color={"black"}
            fontWeight={"bold"}
            fontSize={16}
          >
            Variações do Item
            <ProductItem
              addRow={addRow}
              borderColor={borderColor}
              changeItem={changeItem}
              deleteRow={deleteRow}
              itens={itens}
              condicaoPagamentos={condicaoPagamentos}
            />
          </Text>
        </Box>
        <Box>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </Box>
      </Box>

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>
              {errorMsg}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default FormProduto;
